import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-popups',
  templateUrl: './popups.component.html',
  styleUrls: ['./popups.component.css']
})
export class PopupsComponent implements OnInit {

  constructor(
    private matdialog : MatDialogRef<PopupsComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any,
  ) { 
    matdialog.disableClose = true;
  }

  ngOnInit(): void {
    
  }

  closeModal(){
    this.matdialog.close();
  }

}
